import { useEffect } from 'react'

export const useInterval = ({ action, delay, start }) => {
  useEffect(() => {
    if (typeof action === 'function') {
      if (start) {
        action()
      }
      const interval = setInterval(action, delay * 1000)

      return () => clearInterval(interval)
    }
  }, [delay, action, start])
}
